import TopRelationshipsToMyExecutivesReducer from './TopRelationshipsToMyExecutivesReducer';
import { ProfileRelationshipsToMyExecutivesListReducers } from './containers/ProfileRelationshipsToMyExecutivesList';

export default from './TopRelationshipsToMyExecutivesContainer';
export const TopRelationshipsToMyExecutivesReducers = {
  TopRelationshipsToMyExecutivesReducer,
  ...ProfileRelationshipsToMyExecutivesListReducers,
};
